// extracted by mini-css-extract-plugin
export var deleteIcon = "_su-5";
export var deleteOption = "_su-3";
export var divider = "_su-2";
export var downloadIcon = "_su-4";
export var drawer = "_su-0";
export var drawerFooter = "_su-6";
export var drawerOpen = "_su-1";
export var highlighted = "_su-7";
export var lighterHighlight = "_su-8";